import { render, staticRenderFns } from "./copyright_policy.vue?vue&type=template&id=6e3e201a&scoped=true&"
import script from "./copyright_policy.vue?vue&type=script&lang=js&"
export * from "./copyright_policy.vue?vue&type=script&lang=js&"
import style0 from "./copyright_policy.vue?vue&type=style&index=0&id=6e3e201a&prod&scoped=true&lang=css&"
import style1 from "./copyright_policy.vue?vue&type=style&index=1&id=6e3e201a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3e201a",
  null
  
)

export default component.exports